import React, { useState, useEffect, useContext } from 'react';
import { Pager, PagerState } from '@coveo/headless';
import { headlessEngine } from '../engine';
import { pager } from '../controllers/controller';
import PaginationModule from '../../react-components/pagination';
import { labelsObj } from '../controllers/controller';
import SecondCall from './second-call-context';
import { maxResultsPerPage } from '../controllers/controller';

export const COVEO_PAGINATION_EVENTS = {
  reset: 'pagination:reset'
};

const Pagination = () => {
  const [controller, setController] = useState<Pager>(pager as Pager);
  const [state, setState] = useState<PagerState | null>(null);
  const secondCallContext = useContext(SecondCall);

  useEffect(() => {
    if (headlessEngine) {
      setController(pager as Pager);
      setState((pager as Pager).state);
      (pager as Pager).subscribe(() => {
        setState((pager as Pager).state);
      });
    }

    window.addEventListener(COVEO_PAGINATION_EVENTS.reset, resetPagination);

    return () => {
      window.removeEventListener(
        COVEO_PAGINATION_EVENTS.reset,
        resetPagination
      );
    };
  }, []);

  const resetPagination = () => {
    if (secondCallContext.secondCall && secondCallContext.setSelectedPage) {
      secondCallContext.setSelectedPage(1);
      return;
    }
    controller?.selectPage(1);
  };

  const handleGoToPage = (pageNumber: number) => {
    if (secondCallContext.secondCall && secondCallContext.setSelectedPage) {
      secondCallContext.setSelectedPage(pageNumber);
      return;
    }
    controller?.selectPage(pageNumber);
  };

  if (secondCallContext.secondCall) {
    const _totalPages = Math.ceil(
      secondCallContext.filteredResults.length / maxResultsPerPage
    );
    const _currentPages = Array.from(Array(_totalPages).keys()) || [];
    return (
      <>
        {state && (
          <PaginationModule
            totalPages={_totalPages}
            pagesToShow={_currentPages}
            currentPage={secondCallContext.selectedPage}
            onPageChange={handleGoToPage}
            nextPageLabel={labelsObj.nextPage}
            previousPageLabel={labelsObj.previousPage}
            pageLabel={labelsObj.pageLabel}
          />
        )}
      </>
    );
  }

  return (
    <>
      {state && (
        <PaginationModule
          totalPages={state?.maxPage}
          pagesToShow={state.currentPages}
          currentPage={state.currentPage}
          onPageChange={handleGoToPage}
          nextPageLabel={labelsObj.nextPage}
          previousPageLabel={labelsObj.previousPage}
          pageLabel={labelsObj.pageLabel}
        />
      )}
    </>
  );
};

export default Pagination;
